import styled from 'styled-components';

export const AdHeaderActions = styled.div`
  display: flex;
  gap: 25px;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
`;

export const AdViewMain = styled.div`
  padding: 0 15px;
  margin-bottom: 20px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;
